<template>
    <div>
        <el-dialog
            title="广州市劳动人事争议仲裁委关于在线开庭事项的告知"
            :visible.sync="centerDialogVisible"
            :close-on-click-modal = false
            :close-on-press-escape = false
            :show-close = false
            width="720px"
            center
            class="dialog-content"
            >
            <div class="content">
                <div class="content-wrap">
                    <div class="content-list">
                        <div class="one">一、在线开庭与线下开庭具有同等法律效力,庭审结果将作为案件裁决的重要依据。</div>
                    </div>
                    <div class="content-list">
                        <div class="one">二、本委已提前告知您相关注意事项和庭审纪律，请您确认已按注意事项要求做好准备,并上线后遵守事项规定和庭审纪律。</div>
                    </div>

                    <div class="content-list">
                        <div class="one">三、若因某一方准备不充分导致庭审无法正常进行的，本委将视情况给予其适当的调试时间，超时无法上线或放弃上线的，本委将根据注意事项规定处理。</div>
                    </div>
                </div>
                <el-checkbox class="select" v-model="checked">本人已阅读并同意告知内容</el-checkbox>
                <div class="dialog-footer">
                    <el-button @click="passCase" ref="nextStep">不同意</el-button>
                    <el-button type="primary" :disabled="isDisabled" @click="openCase" ref="nextStep">{{num?'('+num+')':''}}同意</el-button>
                </div>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import { setStore, getStore, removeStore, setStoreSession, getStoreSession,removeStoreSession } from '@/utils/utils.js'

    export default {
        props: ['caseId'],
        data() {
            return {
                centerDialogVisible: true,
                radio2: '2',
                checked: true,
                num:3,
                interval: null,
                params: {},
                commonUserFlag: false,
                currentLoginUserId: null,
                query: {}
            }
        },
        beforeRouteEnter(to, from, next) {
            if(~from.path.indexOf("/meeting")){
                removeStore('isOutter');   
                removeStore('flk');
                removeStoreSession('haslogin');
                removeStore('loginInfo');
                next({ path: '/login'})
            }else{
                next()
            }
        },
        created() {
            this.query = this.$route.query
        },
        mounted() {
            this.countDown()
        },
        methods: {
            openCase() {
                if(this.checked) {
                    switch (this.query.memberType) {
                        case 'ROOM_WATCHER':
                            //无画面观摩人
                            // this.$router.push({ path: '/meeting/roomWatcherNoPic', query: this.query})       //老版本方案无画面观摩人
                            this.$router.push({ path: '/meeting/roomWatcherNoPicnew', query: this.query})       //新版本TCPlayer无画面观摩人
                            break;
                        case 'INVITATION_WATCHER':
                            this.$router.push({ path: '/meeting/meetingWatcher', query: this.query})
                            break;
                        case 'INVITATION_WATCHER2':
                            this.$router.push({ path: '/meeting/meetingWatcher', query: this.query})
                            break;
                        default:
                            this.$router.push({ path: '/meeting/member', query: this.query})
                            break;
                    }
                }
            },
            passCase(){
                removeStore('isOutter');   
                removeStore('flk');
                removeStoreSession('haslogin');
                removeStore('loginInfo');
                this.$router.push({ path: '/login'})
            },
            countDown(value) {
                // if(value == '1') {
                //     this.isDisabled = false
                // } else {
                //     this.isDisabled = true
                // }
                let that = this
                that.interval = setInterval(function() {
                    that.num>0 ? that.num-- : clearInterval(that.interval);
                }, 1000)
                
            }
        },
        computed: {
            isDisabled: function () {
                return !(this.checked&&this.num==0)
            }
        }
    }
</script>

<style lang="scss">
    .dialog-content {
        .content {
            .content-wrap {
                padding: 20px;
                border: 1px solid #dfdfdf;
            }
            .content-list {
                padding-bottom: 20px;
                .one {
                    color: #000000;
                    line-height: 32px;
                    font-size: 14px;
                }
                .two {
                    li {
                        height: 32px;
                        line-height: 32px;
                        text-indent: 0.5em;
                        font-size: 14px;
                        color: #787c7e;
                    }
                }
                .three {
                    line-height: 32px;
                    font-size: 14px;
                    color: #787c7e;
                }
            }
            .select {
                width: 100%;
                text-align: center;
                height: 40px;
                line-height: 60px;
            }
            .dialog-footer {
                padding-top: 26px;
                text-align: center;
            }
        }
    }
</style>
